import { useAuth } from '@/services/auth';

export function useMasqAccessLevel() {
  const auth = useAuth();
  const isMasq = auth.account.is_masq === true;
  return {
    isMasq,
    isMasqWithoutAccess: isMasq && !auth.user.hasReadMasqAccess,
  };
}
